export default __webpack_public_path__ + "static/media/Elite_Embassy.75cd885d.png";